import { mapActions } from 'vuex'
import moment from 'moment'

import { fetch } from '@/services'
import { createBody, extractBody, getCleanLink, getImageUrl, getFeaturedImageFromPost, nl2br, scrollTo, extractYoutubeId, extractVimeoId } from '@/helpers'

export default {
  methods: {
    _ (key, data = {}) {
      if (this.options.constants) {
        const keys = Object.keys(data)
        let string = this.options.constants[key]
        keys.forEach(key => {
          string = string.replace(`%${key}%`, data[key])
        })
        return string
      }
      return undefined
    },
    ...mapActions(['setPage', 'setTransition', 'resetTransition']),
    moment,
    fetch,
    createBody,
    extractBody,
    getCleanLink,
    getImageUrl,
    getFeaturedImageFromPost,
    nl2br,
    scrollTo,
    extractYoutubeId,
    extractVimeoId
  }
}
